import {object, string} from 'yup'
export const signUpSchema = object({
    firstName: string()
        .trim()
        .required('Required')
        .min(3, 'At least 3 characters'),

    lastName: string()
        .trim()
        .required('Required')
        .min(3, 'At least 3 characters'),

    email: string()
        .trim()
        .required('Required')
        .email('Invalid Email'),

    password: string()
        .trim()
        .required('Required')
        .min(6, 'At least 6 characters'),
});
